import React from "react";
import Header from "../components/Header"; //header
import Footer from "../components/Footer"; //footer
import Dashboard from "../components/Dashboard";
import blogImg1 from "../assets/img/blog/blogImg1.png";
import blogImg2 from "../assets/img/blog/blogImg2.png";
import blogImg3 from "../assets/img/blog/blogImg3.png";
import blogImg4 from "../assets/img/blog/blogImg4.png";
import blogImg5 from "../assets/img/blog/blogImg5.png";
import cuteboy from "../assets/img/blog/blogs.png";
import plusicon from "../assets/img/product_img/plusicon.png";
import { Link } from "react-router-dom";
import Breadcrumb from "../Breadcrumb.jsx";
import { Helmet } from "react-helmet-async";
import Card from "../components/Card"; // Import the Card component
import "../components/Card.css"; // Import the Card CSS
import "../pages/Blog.css";
import WhatsappButton from "../components/WhatsappButton.jsx";

const Blog = () => {
  let title = <>Our Latest Insights</>;
  let description = (
    <>
      At Global Entertainment Manufacturer, we continue to lead the way in
      delivering innovative, safe, and high-quality entertainment solutions
      worldwide. From concept to installation, our expertise spans every aspect
      of indoor amusement—from indoor playgrounds and soft play zones to
      full-scale trampoline parks, ninja courses, and family
      entertainment centers.
    </>
  );

  // Card data
  const cardData = [
    {
      id: "1",
      image: blogImg1,
      newtitle:"ChoosetheRightTrampolineParkManufacturer",
      heading: "heading 1",
      title:
        "How to Choose the Right Trampoline Park Manufacturer for Your Business",
      description:
        "Starting a trampoline park is an exciting opportunity—but choosing the right manufacturer is critical to your success. The right partner ensures safety, innovation, and profitability.",
    },
    {
      id: "2",
      image: blogImg2,
      newtitle:"ProcessofTrampolinePark",
      title:
        "Trampoline The Process of Building a Custom Trampoline Park with GEMPLAY",
      description:
        "Wondering how a custom trampoline park is built from concept to completion? Here’s how GEMPLAY, a leading trampoline park manufacturer, brings your vision to life.",
    },
    {
      id: "3",
      image: blogImg3,
      newtitle:"TrampolineParksAreBooming",
      title:
        "Why Trampoline Parks Are Booming Worldwide (And How to Get Started)",
      description:
        "Trampoline parks have become a global trend in family entertainment. Whether in malls, entertainment centers, or stand-alone venues—they’re drawing huge crowds.",
    },
    {
      id: "4",
      image: blogImg4,
      newtitle:"IndoorPlaygroundManufacturer",
      title:
        "Why GEMPLAY Is the Leading Indoor Playground Manufacturer in Jordan",
      description:
        "With the rising demand for family-friendly entertainment in Jordan, the need for high-quality indoor playgrounds has never been greater. GEMPLAY is proud to be Jordan’s premier indoor playground.",
    },
    {
      id: "5",
      image: blogImg5,
      newtitle:"IndoorPlaygroundBusiness",
      title: "How to Start Your Indoor Playground Business in Jordan",
      description:
        "Wondering how a custom Indoor playgrounds are a growing business opportunity in Jordan, especially in urban areas like Amman, Irbid, and Aqaba. If you're considering starting your own, here’s a step-by-step.",
    },
    {
      id: "6",
      image: blogImg5,
      newtitle:"UAESchoolsAreChoosingIndoorPlaygrounds",
      title: "5 Reasons UAE Schools Are Choosing Indoor Playgrounds",
      description:
        "Schools across the UAE are reimagining learning environments to support whole-child development—and indoor playgrounds are leading the way",
    },
    // {
    //   id: "7",
    //   image: blogImg5,
    //   title: "Top 7 Benefits of Visiting a Trampoline Park for Family Fun",
    //   description:
    //     "In today's fast-paced digital world, finding a fun and active way for families to spend time together can be a challenge. That’s where GEM Trampoline Parks come in — offering more than just a bounce! Whether you're in Jordan, UAE, Saudi Arabia, Germany, or the USA, trampoline parks are quickly becoming the go-to destination for energetic, screen-free family experiences.",
    // },
    // {
    //   id: "8",
    //   image: blogImg5,
    //   title: "Starting a Trampoline Park in the Middle East: What You Need to Know",
    //   description:
    //     "The Middle East is witnessing a dynamic shift in how families and youth engage in entertainment — with trampoline parks leading the charge. As demand for active indoor entertainment continues to rise, especially in countries like the UAE, Saudi Arabia, Jordan, and the Gulf, savvy entrepreneurs are exploring this booming sector.",
    // },
    // {
    //   id: "9",
    //   image: blogImg5,
    //   title: "How GEM Transforms Learning Environments in UAE Colleges ",
    //   description:
    //     "In today’s modern education system, learning goes far beyond classrooms and textbooks—especially in forward-thinking colleges across the UAE. Colleges are increasingly reimagining their campuses to support creativity, collaboration, and student wellness. One surprising but powerful contributor to this transformation is GEM, the region’s trusted name in indoor playground and recreational space design. ",
    // },
  ];


  const handleFloatingButtonClick = () => {
  console.log("WhatsApp button clicked!");
  };

  return (
    <div>
      <Helmet>
  <title>Blog | Global Entertainment Manufacturer</title>
  <meta name="description" content="Discover the latest insights and trends in indoor amusement." />
</Helmet>
      <div>
        <Header />
        <Dashboard
          Breadcrumb={
            <div
              style={{
                backgroundColor: "",
                marginTop: "13%",
                marginLeft: "3%",
                borderRadius: "5px",
              }}
            >
              <Breadcrumb />
            </div>
          }
          title={title}
          imageUrl={cuteboy}
          description={description}
        />
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="indoor playground design"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>

        {/* Render the cards */}
        
        <div className="CardContainer"
          
        >
          {cardData.map((data) => (
            <div className="BCards" key={data.newtitle} >
            <Link
              to={`/Blog/${data.newtitle}`}
              style={{ textDecoration: "none" }}
            >
              <Card 
                image={data.image}
                 title={data.title}
                description={data.description}
              />
            </Link>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Blog;
